/* Number ops */

// import Settings from "./settings.service";
import Storage from "./storage.service";
import HTTP from "./http.service";
import { handleError } from "./errors.service";
import { emptyReject } from "./helpers";

var once = false;

const saveCurrentProduct = () => {
	let config = {
		method: "get",
		url: "/products/current?save=true",
	};

	let f = HTTP(config);
	f
		.then((res) => {
			if (res.data && res.data.product) {
				selectProduct(res.data.product, "fff");
			}
		})
		.catch((err) => {});
	return f;
};

// const clear = () => {
// 	once = false;
// };

const sortByCommitment = (a, b) => {
	return a.CommitmentDuration - b.CommitmentDuration;
};

const initProducts = () => {
	if (!Storage.get("products")) {
		getProducts()
			.then((products) => {
				let payg_products = products.data.filter((product) => {
					return product["ProductCategory"] === "PAYG";
				});

				let commitment_products = products.data.filter((product) => {
					return product["ProductCategory"] === "Commitment";
				});

				commitment_products = commitment_products.sort(sortByCommitment);

				Storage.setShared("payg_products", payg_products);

				Storage.setShared("commitment_products", commitment_products);

				Storage.setShared("products", products.data);

				if (!once) {
					once = true;
					fetchCurrentProduct()
						.then((data) => {
							if (data && data.data) {
								let product = null;
								if (data.data.product) {
									product = data.data.product;
								} else {
									product = getDefaultProduct();
								}

								selectProduct(product, "77");

								let flags = Storage.get("flow_status_flags");
								let had_vip_and_lost_it = false;
								if (
									product &&
									flags &&
									!flags.is_number_selected &&
									product["ProductCategory"] === "VIP"
								) {
									had_vip_and_lost_it = true;
								}
								if (had_vip_and_lost_it) {
									saveProduct(getDefaultProduct());
								}
							}
						})
						.catch((error) => {
							handleError(error, 'initProducts getProducts fetchCurrentProduct');
						});
				}
			})
			.catch((error) => {
				if (error !== false) {
					handleError(error, 'initProducts getProducts');
				}
			});
	} else {
		if (!Storage.get("selectedProduct")) {
			let commitment_products = Storage.get("commitment_products");
			if (!once && commitment_products) {
				once = true;
				fetchCurrentProduct()
					.then((data) => {
						if (data && data.data) {
							if (data.data.product) {
								selectProduct(data.data.product);
							} else {
								selectProduct(getDefaultProduct());
							}
						}
					})
					.catch((error) => {
						handleError(error, "initProducts fetchCurrentProduct 2");
					});
			}
		}
	}
};

const getProductByCode = (code) => {
	let products = Storage.get("commitment_products");
	for (let product of products) {
		if ("" + code === "" + product.ProductCode) {
			return product;
		}
	}
	return null;
};

const getProductByCommitment = (duration) => {
	let products = Storage.get("commitment_products");
	for (let product of products) {
		if ("" + duration === "" + product.CommitmentDuration) {
			return product;
		}
	}
	return null;
};

const selectProductByDuration = (duration) => {
	let products = Storage.get("commitment_products");
	let currentProduct = getCurrentProductCommitment();

	if (duration !== currentProduct) {
		for (let product of products) {
			if (duration === product.CommitmentDuration) {
				//log("Selecting product with commitment = " + duration);
				selectProduct(product, "6");
				return;
			}
		}
	}
	//log("no product found with commitment =  " + duration);
};

const isCurrentProductUserSelected = () => {
	let flags = Storage.get("flow_status_flags");
	if (
		flags &&
		flags.is_product_selected &&
		flags.is_plan_selected &&
		!flags.has_vip
	) {
		//log("isCurrentProductUserSelected? Yes");
		return true;
	}
	//log("isCurrentProductUserSelected? No");
	return false;
};

const selectProduct = (product, callee = null) => {
	Storage.set("selectedProduct", product);
};

const selectCommitmentProduct = () => {
	let selectedProduct = Storage.get("selectedProduct");
	if (selectedProduct) {
		let products = Storage.get("commitment_products");
		for (let product of products) {
			if (product.ProductCode === selectedProduct.ProductCode) {
				return;
			}
		}
		selectProduct(getDefaultProduct());
	}
};

const getDefaultProduct = () => {
	let products = Storage.get("commitment_products");
	if (products) {
		return products[0];
	}
	return null;
};

const getCurrentProduct = () => {
	let current = Storage.get("selectedProduct");
	if (current) {
		return current;
	}

	if (!current) {
		return getDefaultProduct();
	}

	return null;
};

const saveProduct = (product = null) => {
	let product_to_save = product ? product : Storage.get("selectedProduct");
	let config = {
		method: "post",
		url: "/products/save",
		data: {
			product_code: product_to_save["ProductCode"],
		},
	};
	return HTTP(config);
};

const saveDefaultProduct = () => {
	let product = getProductByCommitment(1);
	if (product) {
		return saveProduct(product);
	}
	return emptyReject();
};

const getCurrentProductCommitment = (current = null) => {
	let product = getCurrentProduct();
	if (product) {
		return product.CommitmentDuration;
	} else {
		return 1;
	}
};

const fetchCurrentProduct = () => {
	let config = {
		method: "get",
		url: "/products/current",
	};
	return HTTP(config);
};

const fetchProducts = (categories = "Commitment,payg") => {
	if (Storage.get("fetching_products")) {
		return emptyReject();
	}
	Storage.set("fetching_products", true);

	let params = "";
	if (categories) {
		params = "?category=" + categories;
	}
	let config = {
		method: "get",
		url: "/products/available" + params,
	};
	let f = HTTP(config);
	f.finally(() => {
		Storage.clear("fetching_products");
	});
	return f;
};

const getProducts = () => {
	let property = "Products";
	let prop = property.toLowerCase();
	if (Storage.get(prop)) {
		//log("found " + prop + " in storage.. ");
		let data = {
			data: Storage.get(prop),
		};
		return new Promise((resolve, reject) => {
			resolve(data);
		});
	} else {
		//log("fetching " + property + " from api..");
		return fetchProducts();
	}
};

export {
	isCurrentProductUserSelected,
	getProductByCode,
	selectCommitmentProduct,
	saveDefaultProduct,
	selectProductByDuration,
	saveCurrentProduct,
	getCurrentProduct,
	getDefaultProduct,
	initProducts,
	getCurrentProductCommitment,
	selectProduct,
};
